import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Eleccion() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the first step of the eleccion flow
    navigate('/eleccion/respiracion', { replace: true });
  }, [navigate]);

  // This component will redirect immediately, so we don't need to render anything
  return null;
}